import R from 'ramda'

const MATCH_INTENT_TRIGGER_TYPE = 'MATCH_INTENT'
const MATCH_INTENT_DISPLAY_TYPE = 'Match Intent'

const isMatchIntentWidgetTrigger = R.propEq('type', MATCH_INTENT_TRIGGER_TYPE)

const convertMatchIntentWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(MATCH_INTENT_DISPLAY_TYPE),
  ctaPost: R.path(['data', 'ctaPost'])
})

export {
  isMatchIntentWidgetTrigger,
  convertMatchIntentWidgetTriggerToFormTrigger
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/match-intent.js